import AvatarImageView from './avatar-image-view'

export default AvatarImageView
